import { Flex, Icon, Text, useToast, Tooltip } from '@chakra-ui/react'
import * as T from '../../../components/Table'
import { format } from 'date-fns'
import { Link } from 'react-router-dom'
import { FaEdit } from 'react-icons/fa'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../services/api'
import { ModalDeletarCidade } from './ModalDeletarCidade'

async function deleteCidade({ slug }) {
  const response = await api.delete(`/cidades-home/deletar-cidade/${slug}`)

  return response.data
}

export function CidadeItem({ cidade, currentPage }) {
  const queryClient = useQueryClient()
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
  })

  const { mutateAsync: deleteCidadeAsync, isLoading: isLoadingDeleteCidadeAsync } = useMutation({
    mutationKey: 'deleteCidade',
    mutationFn: ({ slug }) => deleteCidade({ slug }),
    onSuccess: (data) => {
      const { slug } = data

      // Atualiza o cache localmente para evitar refetch
      queryClient.setQueryData(['cidades', { page: currentPage, limit: 30 }], (oldData) => {
        if (!oldData) return oldData

        return {
          ...oldData,
          cidades: oldData.cidades.filter((cidade) => cidade.slug !== slug),
          total_aprovado_e_em_aprovacao: oldData.total_aprovado_e_em_aprovacao - 1,
          ...(cidade.aprovado ? { total_aprovados: oldData.total_aprovados - 1 } : { total_em_aprovacao: oldData.total_em_aprovacao - 1 }),
        }
      })

      toast({
        title: 'Cidade deletada com sucesso',
        status: 'success',
      })
    },
    onError: (error) => {
      toast({
        title: 'Erro ao deletar a Cidade',
        description: error.response?.data?.message || 'Ocorreu um erro inesperado',
        status: 'error',
      })
    },
  })

  async function handleDeleteCidade(slug) {
    await deleteCidadeAsync({ slug })
  }

  return (
    <T.Tr key={cidade.artigo_id}>
      <T.Td textAlign="start" px={2} py="1" borderRight="1px solid #378BBF!important">
        <Tooltip label={cidade.aprovado ? 'Clique para abrir a página da cidade' : 'Cidade não aprovada'} placement="top">
          <Text
            isTruncated
            textTransform={'initial'}
            as={cidade.aprovado ? 'a' : 'span'}
            href={`https://innovationbrindes.com.br/brindes/${cidade.slug}`}
            target="_blank"
            rel="noreferrer"
            {...(cidade.aprovado && { color: 'blue.500', textDecoration: 'underline' })}
            maxW="250px"
          >
            {cidade.nome_cidade}
          </Text>
        </Tooltip>
      </T.Td>
      <T.Td py="1" w="250px" borderRight="1px solid #378BBF!important">
        <Text textTransform={'lowercase'}>{cidade.dt_criacao ? format(new Date(cidade.dt_criacao), "dd/MM/yyyy 'às' HH:mm") : 'Sem data'}</Text>
      </T.Td>
      <T.Td py="1" w="100px" borderRight="1px solid #378BBF!important">
        {cidade?.data_aprovacao && (
          <Flex flexDir="column" alignItems="center">
            <Text textTransform="lowercase">{format(new Date(cidade.data_aprovacao), "dd/MM/yyyy 'às' HH:mm")}</Text>
            <Text>
              <strong>{cidade.usuario_aprovacao}</strong>
            </Text>
          </Flex>
        )}
      </T.Td>
      <T.Td py="1" w="100px" borderRight="1px solid #378BBF!important">
        <Tooltip label="Editar cidade" placement="top">
          <Flex as={Link} to={`/adm/cidade/${cidade.slug}`} alignItems="center" justifyContent="center" gap={2} cursor="pointer">
            <Text>Editar</Text>
            <Icon as={FaEdit} fontSize="lg" color="#FFA200" />
          </Flex>
        </Tooltip>
      </T.Td>

      <T.Td py="1" w="100px">
        <ModalDeletarCidade onConfirm={() => handleDeleteCidade(cidade.slug)} isLoading={isLoadingDeleteCidadeAsync} />
      </T.Td>
    </T.Tr>
  )
}
